import {useProducts} from './use-products';
import {Button} from '../../ui/buttons/button';
import {Trans} from '../../i18n/trans';
import {ForumIcon} from '../../icons/material/Forum';
import {Navbar} from '../../ui/navigation/navbar/navbar';
import {Link} from 'react-router-dom';
import {Footer} from '../../ui/footer/footer';
import {Fragment, useState} from 'react';
import {UpsellBillingCycle} from './find-best-price';
import {BillingCycleRadio} from './billing-cycle-radio';
import {StaticPageTitle} from '../../seo/static-page-title';
import {PricingTable} from '@common/billing/pricing-table/pricing-table';

export function PricingPage() {
  const query = useProducts('pricingPage');
  const [selectedCycle, setSelectedCycle] =
    useState<UpsellBillingCycle>('yearly');

  return (
    <Fragment>
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>

      <Navbar
        color="bg"
        darkModeColor="transparent"
        border="border-b"
        menuPosition="pricing-table-page"
      />

      {/* Wider container + responsive padding for bigger cards */}
      <div className="mx-auto w-full max-w-screen-2xl px-16 md:px-24 lg:px-32">
        {/* Title block */}
        <div className="mb-40 mt-30 text-center md:mt-60 md:mb-60">
          <h1 className="text-4xl font-medium tracking-tight md:text-5xl">
            <Trans message="Choose the right plan for you" />
          </h1>
          <p className="mx-auto mt-14 max-w-3xl text-base text-muted md:text-lg">
            <Trans message="Start for free and upgrade when you need more scale, collaboration, or custom domains." />
          </p>
        </div>

        {/* Billing cycle toggle */}
        <BillingCycleRadio
          products={query.data?.products}
          selectedCycle={selectedCycle}
          onChange={setSelectedCycle}
          className="mb-50 flex justify-center md:mb-70"
          size="lg"
        />

        {/* Pricing table */}
        {/* NOTE: if PricingTable has its own max-width wrapper, remove it there too */}
        <div className="w-full">
          <PricingTable
            selectedCycle={selectedCycle}
            productLoader="pricingPage"
          />
        </div>

        <ContactSection />
      </div>

      <Footer className="mx-auto w-full max-w-screen-2xl flex-shrink-0 px-16 md:px-24 lg:px-32" />
    </Fragment>
  );
}

function ContactSection() {
  return (
    <div className="my-30 rounded-2xl border bg-paper/40 p-24 text-center shadow-sm md:my-90">
      <ForumIcon size="xl" className="mx-auto text-muted" />
      <div className="my-10 text-base font-medium md:text-xl">
        <Trans message="Do you have any questions about PRO accounts?" />
      </div>
      <div className="mb-24 text-sm text-muted md:text-base">
        <Trans message="Our support team will be happy to assist you." />
      </div>
      <Button variant="flat" color="primary" elementType={Link} to="/contact">
        <Trans message="Contact us" />
      </Button>
    </div>
  );
}
